import { atom, selector } from 'recoil'

export const updateDetailsLogState = atom<any[]>({
    key: 'update_details_log_state',
    default: [],
})

export const updateLogErrorCount = selector<number>({
    key: 'update_log_error_count',
    get: ({ get }) => {
        const log = get(updateDetailsLogState)
        return log.filter((entry) => {
            return entry.level === 'ERROR'
        }).length
    },
})
